module.exports = __webpack_public_path__ + "static/media/muli-latin-200italic.787c91cf.woff";